export enum LiCompanyActivityType {
	LIKE = "LIKE",
	COMMENT = "COMMENT",
	VISIT = "VISIT",
	COMPANY_VISIT = "COMPANY_VISIT",
	COMPANY_FOLLOWER = "COMPANY_FOLLOWER",
}

export enum LiCompanyActivityTimeframe {
	NOW = "NOW",
	THIS_MONTH = "THIS_MONTH",
	LAST_MONTH = "LAST_MONTH",
	LAST_3_MONTHS = "LAST_3_MONTHS",
	LAST_6_MONTHS = "LAST_6_MONTHS",
	LAST_YEAR = "LAST_YEAR",
}
